import cloneDeep from 'lodash/cloneDeep';
import * as allTypes from '@/store/mutation-type';
import getAll from '@/api/ligneCommandeRecherche';
import getAllLigneCommandeView from '@/api/ligneCommandeView';
import genererCritereRechercheLigneCommande
  from '@/services/bodac/lignesCommande/critereRecherche/genererCritereRechercheLignesCommande';
import genererCriteresRechercheLigneARenouveler
  from '@/services/bodac/lignesCommande/critereRecherche/genererCriteresRechercheLigneARenouveler';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';
import trierParNomCommercial from '@/services/devisCommandes/trierParNomCommercial';
import { DEVIS_COMMANDE_ETAT } from '@/configuration/devisConf';
import transformer from '@/services/ligneCommande/ligneDcfServerTableDataTransformer';
import transformRenouvellement from '@/services/devisCommandes/filters/renouvellementServerTableDataTransformer';
import * as clientConf from '@/configuration/tiers/tiersConf';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import { getSoldeMouvementStock } from '@/api/mouvementStock';
import formatDateIso from '@/services/general/formatIsoDate';
import * as types from './commandeParligneCommande-mutation-type';

export function initialState(nameStore) {
  return {
    items: [],
    totalCount: 0,
    criteresRecherche: genererCritereRechercheLigneCommande(nameStore),
    lignesARenouveler: [],
    totalCountARenouveler: 0,
    criteresRechercheARenouveler: genererCriteresRechercheLigneARenouveler(),
    lastPayload: {},
    lastPayloadARenouveler: {},
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_ITEMS](state, items) {
    state.items = items;
  },
  [types.SET_TOTAL](state, count) {
    state.totalCount = count;
  },
  [types.SET_CRITERE](state, critere) {
    state.criteresRecherche = critere;
  },
  [types.SET_CRITERE_A_RENOUVELER](state, critere) {
    state.criteresRechercheARenouveler = critere;
  },
  [types.SET_TOTAL_A_RENOUVELER](state, count) {
    state.totalCountARenouveler = count;
  },
  [types.SET_LIGNES_A_RENOUVELER](state, count) {
    state.lignesARenouveler = count;
  },
  [types.SET_LAST_PAYLOAD](state, payload) {
    state.lastPayload = payload;
  },
  [types.SET_LAST_PAYLOAD_A_RENOUVELER](state, payload) {
    state.lastPayloadARenouveler = payload;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  async loadLigneCommande({ commit }, search) {
    const dataToSend = transformer(cloneDeep(search));
    commit(types.SET_LAST_PAYLOAD, dataToSend);
    const data = (await getAllLigneCommandeView(dataToSend)).data.result;
    data.items.forEach((ligne) => {
      if (ligne.commercialId) {
        ligne.nomCommercial = nomPrenomGetter({
          nom: ligne.commercialNom,
          prenom: ligne.commercialPrenom,
        });
      }
      const etat = DEVIS_COMMANDE_ETAT.find((etatInList) => {
        return etatInList.code === ligne.etatDcf;
      });
      ligne.etatLibelle = etat ? etat.libelle : '';
      ligne.listeIntervenants = ligne.clientsNomsCommerciaux.map((el) => el).join(', ');
    });
    commit(types.SET_ITEMS, data.items);
    commit(types.SET_TOTAL, data.totalCount);
    return {};
  },
  async loadLigneCommandeARenouveler({ commit, rootState }, search) {
    const dataToSend = transformRenouvellement(cloneDeep(search));
    commit(types.SET_LAST_PAYLOAD_A_RENOUVELER, dataToSend);
    const data = (await getAll(dataToSend)).data.result;
    data.items.forEach((ligne) => {
      ligne.selected = false;
      if (ligne.devisCommande.commercial) {
        ligne.nomCommercial = nomPrenomGetter(ligne.devisCommande.commercial);
      }
      const etat = DEVIS_COMMANDE_ETAT.find((etatInList) => {
        return etatInList.code === ligne.devisCommande.etat;
      });
      ligne.etatLibelle = etat ? etat.libelle : '';
      const annonceurs = ligne.devisCommande.intervenants
        .filter(intervenant => intervenant.annonceur);
      if (rootState.parametres
        .parametresInterne[PARAMETRES_INTERNE_KEYS.ligneCommandeARenouvelerSpe.key]) {
        const tiers = annonceurs[0].tiers;
        if (tiers) {
          ligne.marques = tiers.tiersMarques.map((el) => el.marque.libelle).join(', ');
          if (tiers.typologie === clientConf.TYPOLOGIE_POINT_DE_VENTE && tiers.tiersParent) {
            ligne.enseigneId = tiers.tiersParentId;
            ligne.enseigne = tiers.tiersParent.nomCommercial;
            if (tiers.tiersParent.tiersParent) {
              ligne.groupeId = tiers.tiersParent.tiersParentId;
              ligne.groupe = tiers.tiersParent.tiersParent.nomCommercial;
            }
          } else if (tiers.typologie === clientConf.TYPOLOGIE_ENSEIGNE && tiers.tiersParent) {
            ligne.groupeId = tiers.tiersParentId;
            ligne.groupe = tiers.tiersParent.nomCommercial;
          }
        }
      }
      trierParNomCommercial(annonceurs);
      ligne.listeAnnonceurs = annonceurs;
      const payeurs = ligne.devisCommande.intervenants
        .filter(intervenant => intervenant.payeur);
      trierParNomCommercial(payeurs);
      ligne.listePayeurs = payeurs;
    });
    if (rootState.parametres
      .parametresInterne[PARAMETRES_INTERNE_KEYS.ligneCommandeARenouvelerSpe.key]) {
      const tiersIds = [];
      data.items.forEach(ligne => {
        const intervenant = ligne.devisCommande.intervenants
          .find(inter => inter.annonceur);
        tiersIds.push(intervenant.tiersId);
      });
      const allSoldeByTiers = (await getSoldeMouvementStock({
        tiersIds: tiersIds,
        dateSolde: formatDateIso(new Date()),
      })).data.result;
      data.items.forEach(ligne => {
        const intervenant = ligne.devisCommande.intervenants
          .find(inter => inter.annonceur);
        ligne.soldeAnnonceur = allSoldeByTiers[intervenant.tiersId] ?? 0;
      });
    }
    commit(types.SET_LIGNES_A_RENOUVELER, data.items);
    commit(types.SET_TOTAL_A_RENOUVELER, data.totalCount);
    return {};
  },
};

const getters = {
  items: state => {
    return state.items;
  },
  totalCount: state => {
    return state.totalCount;
  },
  criteresRecherche: state => {
    return state.criteresRecherche;
  },
  lignesARenouveler: state => {
    return state.lignesARenouveler;
  },
  totalCountARenouveler: state => {
    return state.totalCountARenouveler;
  },
  criteresRechercheARenouveler: state => {
    return state.criteresRechercheARenouveler;
  },
  lastPayload: state => {
    return state.lastPayload;
  },
  lastPayloadARenouveler: state => {
    return state.lastPayloadARenouveler;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
